import axios from "axios";
import { authHeaderFile, authHeaderJson, authHeaderTextPlainJsonPatch } from "../auth-header.service";

const getKPIPayload = (lElementsId, periodId) => {
    return axios.post(`/api/Bulk/kpiDownloadPayload`, { l_element_id: lElementsId, periodo_id: periodId }, { headers: authHeaderJson() });
};

const getPartidaPayload = (lElementsId, periodId) => {
    return axios.post(`/api/Bulk/partidaDownloadPayload`, { l_element_id: lElementsId, periodo_id: periodId }, { headers: authHeaderJson() });
};

const getBookPayload = () => {
    return axios.post(`/api/Bulk/bookDownloadPayload`, { headers: authHeaderJson() });
};

const getEdPPayload = (elementsId, edpId) => {
    return axios.post(`/api/Bulk/edpDownloadPayload`, { element_id: elementsId, edp_id: edpId }, { headers: authHeaderJson() });
};

const postValidateKPIDocument = (documentId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/Bulk/kpiValidatePayload/${documentId}`, { headers: authHeaderJson() });
};

const postValidatePartidaDocument = (documentId, elementId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/Bulk/partidaValidatePayload/${documentId}/${elementId}`, { headers: authHeaderJson() });
};
const postValidateBookDocument = (documentId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/Bulk/bookValidatePayload/${documentId}`, { headers: authHeaderJson() });
};
const postValidateEdPDocument = (documentId, elementId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/Bulk/edpValidatePayload/${documentId}/${elementId}`, { headers: authHeaderJson() });
};


export {
    getKPIPayload,
    getPartidaPayload,
    getBookPayload,
    getEdPPayload,
    postValidateKPIDocument,
    postValidatePartidaDocument,
    postValidateEdPDocument,
    postValidateBookDocument
}